import { getDateTime } from 'services/types';
import { ZonesIcons } from 'libs/ui';

export const bookingStatuses = {
  OFFER: 'Заявка',
  PAID: 'Оплачено',
  STARTED: 'Начато',
  FINISHED: 'Окончено',
  ABANDONED: 'Отменено',
};

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      {
        name: 'zone_id',
        title: t('grid.Зона'),
        with: 80,
        render: (val) => <ZonesIcons stayZones={[val]} />,
      },
      { name: 'status', sortField: 'status', title: t('grid.Статус'), width: 120, render: (val) => bookingStatuses[val] ?? val },
      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 130 },
      { name: 'start_at', sortField: 'start_at', title: t('grid.Начало'), width: 200, render: (val) => getDateTime(val) },
      { name: 'end_at', sortField: 'end_at', title: t('grid.Конец'), width: 200, render: (val) => getDateTime(val) },
      { name: 'client_name', title: t('grid.Имя') },
      { name: 'vehicle_brand', title: t('grid.Марка авто'), width: 100 },
      { name: 'vehicle_model', title: t('grid.Модель авто'), width: 100 },
      { name: 'client_phone', title: t('grid.Телефон'), width: 130 },
      { name: 'client_email', title: t('grid.Email'), width: 150 },
    ];

    return fields;
  };

  return { getFields };
};
